'use client';

import { faChevronDown } from '@fortawesome/pro-light-svg-icons';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { faceToFaceServiceId } from '@/app/(main)/(pages)/_components/face-to-face-service-section/consts/face-to-face-service-section.const';
import { Button } from '@/components/ui/button/button.component';
import { cn } from '@/utils/cn-tw-merge';
import { ButtonColor } from '@/components/ui/button/button.types';

interface NotifyMeButtonProps {
  className?: string;
  color?: ButtonColor;
}

export const NotifyMeButton = ({ className, color = 'success' }: NotifyMeButtonProps) => {
  const handleClickButton = (): void => {
    const section = document.getElementById(faceToFaceServiceId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <Button
      data-testid={DataTestIdEnum.CITY_NOTIFY_ME_BUTTON}
      color={color}
      startIcon={faChevronDown}
      className={cn('h-12', className)}
      onClick={handleClickButton}
    >
      Quero ser avisado
    </Button>
  );
};
